// extracted by mini-css-extract-plugin
module.exports = {"select":"onfido-sdk-ui-Select-select"};